import React from "react";
import { Button } from "@mui/material";
import QuantitySelector from "../OptionChooser/QuantitySelector";
import "../../../pages/ImprovedShopPage/styles/SingleProductPage.css";

interface ProductPriceProps {
  price: number;
  quantity: number;
  onQuantityChange: (newQuantity: number) => void;
}

export const ProductPrice: React.FC<ProductPriceProps> = ({
  price,
  quantity,
  onQuantityChange,
}) => {
  return (
    <div className="single-product-page-quantity-price-row">
      <QuantitySelector quantity={quantity} setQuantity={onQuantityChange} />
      <p className="single-product-page-price ml-auto">${price.toFixed(2)}</p>
    </div>
  );
};

export default ProductPrice;
